const defaultStyleModifier = (function () {
	const regex = /^(-?\d+)(p|m)([tblrxy]{0,1})$/;
	const mapping = {
		type: {
			p: 'padding',
			m: 'margin'
		},
		direction: {
			t: 'Top',
			b: 'Bottom',
			l: 'Left',
			r: 'Right',
			'': '',
			x: ['Left', 'Right'],
			y: ['Top', 'Bottom']
		}
	};

	return function (element, binding) {
		Object.keys(binding.modifiers).forEach((modifier) => {
			const matched = modifier.match(regex);

			if (!matched || matched.length !== 4) {
				return;
			}

			const type = mapping.type[matched[2]];
			const value = `${matched[1]}px`;
			if (matched[3] === 'x' || matched[3] === 'y') {
				mapping.direction[matched[3]].forEach((direction) => {
					element.style[`${type}${direction}`] = value;
				});
			} else {
				const direction = mapping.direction[matched[3]];
				element.style[`${type}${direction}`] = value;
			}
		});
	};
})();

const positionModifier = (function () {
	const regex = /^(-?\d+)([tblr]{1})$/;
	const directions = {
		t: 'top',
		b: 'bottom',
		l: 'left',
		r: 'right'
	};

	return function (element, binding) {
		let applied = 0;
		
		Object.keys(binding.modifiers).forEach((modifier) => {
			const matched = modifier.match(regex);

			if (!matched || matched.length !== 3) {
				return;
			}

			const direction = directions[matched[2]];
			const value = `${matched[1]}px`;
			
			element.style[direction] = value;
			applied++;
		});
		
		if (applied) {
			element.style.position = 'relative';
		}
	};
})();

export default {
	bind(element, binding) {
		switch (binding.arg) {
		case 'rel':
			positionModifier(element, binding);
			break;
		default:
			defaultStyleModifier(element, binding);
		}

	}
};
